import { render, staticRenderFns } from "./questionAnswerManageList.vue?vue&type=template&id=21c295a5&scoped=true"
import script from "./questionAnswerManageList.vue?vue&type=script&lang=js"
export * from "./questionAnswerManageList.vue?vue&type=script&lang=js"
import style0 from "./questionAnswerManageList.vue?vue&type=style&index=0&id=21c295a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c295a5",
  null
  
)

export default component.exports